<div class="">
  <!--begin::Profile Personal Information-->
  <div class="d-flex flex-row">
    <!--begin::Aside-->
    <div class="flex-row-auto w-250px w-xxl-300px" id="kt_profile_aside" *ngIf="doctor?.id">
      <!--begin::Profile Card-->
      <div class="card card-custom card-stretch panel_1">
        <!--begin::Body-->
        <div class="card-body pt-4">
          <!--begin::User-->
          <div
            class="d-flex align-items-center"
            style="margin-bottom: 20px; justify-content: center"
          >
            <span class="symbol symbol-70 symbol-xxl-100 align-self-start align-self-xxl-center">
              <span>
                <div>
                  <div class="image-input image-input-outline image-input-changed">
                    <img
                      class="image-input-wrapper"
                      id="contact_profile"
                      src="{{ doctorProfile }}"
                      style="width: 150px; height: 150px"
                      alt="facilityProfile"
                    />
                    <label
                      *ngIf="!isViewMode"
                      class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow dropdown-toggle dropdown-toggle-split"
                      data-action="change"
                      data-toggle="dropdown"
                      title=""
                      data-original-title="Change avatar"
                    >
                      <i class="fa fa-pen icon-sm text-muted"></i>
                    </label>
                    <span
                      *ngIf="doctor.pre_signed_url?.url"
                      class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow magnify-icon"
                      data-action="zoom"
                      (click)="showDoctorPhoto(doctor)"
                      matTooltip="Zoom in"
                    >
                      <i class="flaticon-search-magnifier-interface-symbol icon-nm text-muted"></i>
                    </span>
                    <div class="dropdown-menu dropdown-menu-sm dropdown-menu-left">
                      <a class="dropdown-item" (click)="updateProfile()"> Upload photo </a>
                    </div>
                  </div>
                </div>
              </span>
            </span>
          </div>
          <!--end::User-->
          <div>
            <div class="mb-5">
              <div
                style="max-width: 240px; overflow: hidden; margin: auto; text-align: center"
                class="main-cont"
              >
                <p
                  class="font-weight-bolder text-dark-75 mb-0 title-one"
                  [innerText]="firstLine()"
                ></p>
                <p
                  class="font-weight-bolder text-dark-75 mb-0 title-two"
                  [innerText]="secondLine()"
                ></p>
              </div>
            </div>
          </div>
          <!--begin::Contact-->
          <div class="py-3" style="padding-left: 1.5rem">
            <div
              class="d-flex align-items-center justify-content-left mb-5"
              matTooltip="Office Phone"
            >
              <span class="font-weight-bold mr-2">
                <i class="fa flaticon2-phone" aria-hidden="true"></i>
              </span>
              <a class="text-muted text-hover-primary"
                >{{ doctor ? (doctor.office_phone | mask : '(000) 000-0000') : '' }}
                {{ doctor.extension ? ' Ext. ' + doctor.extension : '' }}
              </a>
            </div>
            <div
              class="d-flex align-items-center justify-content-left mb-5"
              matTooltip="Cell Phone"
            >
              <span class="font-weight-bold mr-2"> <i class="fas fa-mobile-alt icon-md"></i> </span>
              <a class="text-muted text-hover-primary">{{
                doctor ? (doctor.cell_phone | mask : '(000) 000-0000') : ''
              }}</a>
            </div>
            <div
              class="d-flex align-items-center justify-content-left mb-5"
              [matTooltip]="doctor ? doctor.email : ''"
            >
              <span class="font-weight-bold mr-2">
                <i class="fa flaticon2-black-back-closed-envelope-shape" aria-hidden="true"></i
              ></span>
              <a
                class="text-muted text-hover-primary ellipsis"
                href="mailto:{{ doctor ? doctor.email : '' }}"
                >{{ doctor ? doctor.email : '' }}</a
              >
            </div>
            <div
              class="d-flex align-items-center justify-content-left mb-5"
              [matTooltip]="addressLine('tooltip')"
            >
              <span class="font-weight-bold mr-2">
                <i class="fa flaticon2-pin" aria-hidden="true"></i>
              </span>
              <a
                [innerText]="addressLine()"
                class="text-muted text-hover-primary address-line ellipsis"
              ></a>
            </div>
          </div>
          <!--end::Contact-->
        </div>
        <!--end::Body-->
      </div>
      <!--end::Profile Card-->
      <!--begin::Profile Card-->
      <div class="card card-custom card-stretch panel_2">
        <!--begin::Body-->
        <div class="card-body pt-4">
          <!--begin::Nav-->
          <div class="navi navi-bold navi-hover navi-active navi-link-rounded">
            <ng-container
              *ngFor="let tab of tabs"
              [ngTemplateOutlet]="navi_item"
              [ngTemplateOutletContext]="{ tab: tab }"
            ></ng-container>
            <ng-template #navi_item let-tab="tab">
              <div *ngxPermissionsOnly="tab.permission" class="navi-item mb-2 clickable">
                <a
                  class="navi-link py-4"
                  [ngClass]="{ active: tab.active }"
                  (click)="changeTab(tab.index)"
                >
                  <span class="navi-icon mr-2">
                    <i class="{{ tab.icon }}"></i>
                  </span>
                  <span class="navi-text font-size-lg">{{ tab.label }}</span>
                </a>
              </div>
            </ng-template>
          </div>
          <!--end::Nav-->
        </div>
        <!--end::Body-->
      </div>
      <!--end::Profile Card-->
    </div>
    <!--end::Aside-->

    <!--begin::Content-->
    <div
      class="flex-row-fluid"
      [ngStyle]="doctor?.id ? { 'margin-left': '8px' } : { 'margin-left': '0' }"
      style="min-height: 1650px"
    >
      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[0].active">
        <!--begin::Header-->
        <div class="card-header py-3">
          <div class="card-title align-items-start flex-column">
            <h3 class="card-label font-weight-bolder text-dark">
              {{
                doctor?.id
                  ? (doctor.first_name ? doctor.first_name : '') +
                    ' ' +
                    (doctor.middle_name ? doctor.middle_name : '') +
                    ' ' +
                    (doctor.last_name ? doctor.last_name : '') +
                    ' ' +
                    (doctor.last_name2 ? doctor.last_name2 : '') +
                    '’s
              Doctor Information'
                  : 'New Doctor'
              }}
            </h3>
            <span class="text-muted font-weight-bold font-size-sm mt-1"
              >{{ doctor?.id ? 'Update ' : 'Add ' }} doctor information</span
            >
          </div>
          <div class="card-toolbar">
            <a
              ktBackButton
              class="btn btn-secondary mr-2"
              mat-raised-button
              matTooltip="{{ 'AUTH.INPUT.BACK' | translate }}"
              *ngIf="!entity_id"
            >
              <i class="la la-arrow-left"></i>
              <span class="hidden-mobile"> {{ 'AUTH.INPUT.BACK' | translate }}</span>
            </a>
            <ng-template ngxPermissionsOnly="canEditDoctor">
              <a
                *ngIf="isViewMode"
                (click)="editDoctor(doctor.id)"
                class="btn btn-secondary mr-2"
                mat-raised-button
                matTooltip="Edit Doctor"
              >
                <span class="hidden-mobile" translate="GLOBAL.EDIT">Edit</span>
              </a>
            </ng-template>
            <a
              href="javascript:"
              *ngIf="doctor && !doctor.id"
              class="btn btn-secondary mr-2"
              (click)="reset()"
              mat-raised-button
              matTooltip="{{ 'AUTH.RESET.BUTTON' | translate }}"
            >
              <i class="la la-cog"></i>
              <span class="hidden-mobile">{{ 'AUTH.RESET.BUTTON' | translate }}</span>
            </a>
            <a
              class="btn btn-primary mr-2"
              *ngIf="!isViewMode"
              color="primary"
              (click)="onSubmit()"
              mat-raised-button
              matTooltip="Save & Continue"
            >
              <span class="hidden-mobile"> {{ 'AUTH.INPUT.SAVE' | translate }}</span>
            </a>
          </div>
        </div>
        <!--end::Header-->

        <!--begin::Form-->
        <form class="form" [formGroup]="doctorForm" *ngIf="loadingData">
          <kt-alert
            *ngIf="hasFormErrors"
            type="warn"
            [showCloseButton]="true"
            [duration]="10000"
            (closeAl)="onAlertClose()"
          >
            {{ 'AUTH.VALIDATION.INVALID_OR_REQUIRED' | translate }}
          </kt-alert>
          <kt-alert
            *ngIf="hasSubmissionErrors && !hasFormErrors"
            type="warn"
            [duration]="30000"
            [showCloseButton]="true"
            (closeAl)="onAlertClose()"
          >
            <ul>
              <li *ngFor="let msg of submissionErrorObj">{{ msg.error | translate }}</li>
            </ul>
          </kt-alert>
          <!--begin::Body-->
          <div class="card-body">
            <div class="row">
              <h5 class="font-weight-bold mb-6">Practice Information</h5>
            </div>
            <div class="form-group row">
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>Practice Name</mat-label>
                  <input
                    matInput
                    placeholder="Enter Practice Name"
                    formControlName="practice_name"
                    autocomplete="kt-doctor-first-name"
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <h5 class="font-weight-bold mb-6">Doctor Demographics</h5>
            </div>
            <div class="form-group row">
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'PATIENT.INPUT.FIRST_NAME' | translate }}</mat-label>
                  <input
                    matInput
                    placeholder="Enter First Name"
                    formControlName="first_name"
                    autocomplete="kt-doctor-first-name"
                    required
                  />
                  <mat-error
                    >{{ 'PATIENT.INPUT.FIRST_NAME' | translate }}
                    <strong>{{ 'PATIENT.VALIDATION.REQUIRED' | translate }}</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'PATIENT.INPUT.MIDDLE_NAME' | translate }}</mat-label>
                  <input
                    matInput
                    placeholder="Enter Middle Name"
                    formControlName="middle_name"
                    autocomplete="kt-doctor-middle-name"
                  />
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'PATIENT.INPUT.LAST_NAME' | translate }}</mat-label>
                  <input
                    matInput
                    placeholder="Enter Last Name"
                    formControlName="last_name"
                    autocomplete="kt-doctor-last-name"
                    required
                  />
                  <mat-error
                    >{{ 'PATIENT.INPUT.LAST_NAME' | translate }}
                    <strong>{{ 'PATIENT.VALIDATION.REQUIRED' | translate }}</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'PATIENT.INPUT.LAST_NAME_2' | translate }}</mat-label>
                  <input
                    matInput
                    placeholder="Enter Last Name 2"
                    formControlName="last_name2"
                    autocomplete="kt-doctor-last-name-2"
                  />
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'DOCTOR.INPUT.DOCTOR_ID' | translate }}</mat-label>
                  <input
                    matInput
                    formControlName="doctor_id"
                    maxlength="9"
                    [readonly]="readOnly"
                    autocomplete="kt-doctor-id"
                  />
                  <mat-error *ngIf="isControlHasError('doctor_id', 'required')">
                    {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
                  </mat-error>
                  <mat-error *ngIf="isControlHasError('doctor_id', 'pattern')">
                    Source System ID must be alphanumeric
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-2 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label>Gender</mat-label>
                  <mat-select formControlName="gender">
                    <mat-option value="MALE">Male</mat-option>
                    <mat-option value="FEMALE">Female</mat-option>
                    <mat-option value="">Undefined</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'DOCTOR.INPUT.EMAIL' | translate }}</mat-label>
                  <input
                    type="email"
                    matInput
                    formControlName="email"
                    [readonly]="readOnly"
                    autocomplete="kt-doctor-email"
                  />
                  <mat-error *ngIf="isControlHasError('email', 'email')">
                    {{ 'AUTH.EMAIL' | translate }}
                  </mat-error>
                  <mat-error *ngIf="isControlHasError('email', 'required')">
                    {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <kt-general-autocomplete
                  [label]="'Office'"
                  [loadItemsFunction]="officeAutocompleteCall"
                  [optionFormatter]="officeOptionFormatter"
                  [valueFormatter]="officeOptionFormatter"
                  [readOnly]="readOnly"
                  [control]="doctorForm.get('office_id')"
                  [change]="onOfficeChange.bind(this)"
                  [placeholder]="'Office'"
                  #autocompleteComponent
                ></kt-general-autocomplete>
              </div>
              <div class="col-lg-3 kt-margin-bottom-20-mobile">
                <div class="mat-form-field-fluid">
                  <mat-label class="row ml-1" translate="DOCTOR.INPUT.STATUS">Status</mat-label>
                  <mat-slide-toggle
                    class="mr-2"
                    formControlName="is_active"
                    [disabled]="readOnly"
                  ></mat-slide-toggle>
                  <mat-hint align="start">
                    <strong>{{ getStatusString() }}</strong>
                  </mat-hint>
                </div>
              </div>
            </div>
            <div class="row">
              <h5 class="font-weight-bold mb-6">Contacts</h5>
            </div>
            <div class="form-group row">
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'DOCTOR.INPUT.CELL_PHONE' | translate }}</mat-label>
                  <input
                    matInput
                    formControlName="cell_phone"
                    maxlength="14"
                    ktAppPhoneMask
                    [readonly]="readOnly"
                    autocomplete="kt-doctor-cellphone"
                  />
                  <mat-error *ngIf="isControlHasError('cell_phone', 'pattern')">
                    {{ 'AUTH.VALIDATION.PATTERN' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'DOCTOR.INPUT.FAX' | translate }}</mat-label>
                  <input
                    matInput
                    formControlName="fax"
                    maxlength="14"
                    ktAppPhoneMask
                    [readonly]="readOnly"
                    autocomplete="kt-doctor-fax"
                  />
                  <mat-error *ngIf="isControlHasError('fax', 'pattern')">
                    {{ 'AUTH.VALIDATION.PATTERN' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-2 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>Office Number</mat-label>

                  <input
                    matInput
                    formControlName="office_phone"
                    maxlength="14"
                    ktAppPhoneMask
                    [readonly]="readOnly"
                    autocomplete="kt-doctor-office-phone"
                  />

                  <mat-error *ngIf="isControlHasError('office_phone', 'pattern')">
                    {{ 'AUTH.VALIDATION.PATTERN' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-2 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
                  <mat-label>Extension</mat-label>
                  <input
                    matInput
                    placeholder="Enter Extension"
                    formControlName="extension"
                    maxlength="7"
                    autocomplete="kt-patient-extension"
                  />
                  <mat-hint><strong>Must be less than 7 digit</strong></mat-hint>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <h5 class="font-weight-bold mb-6">Address</h5>
            </div>
            <div class="form-group row">
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'DOCTOR.INPUT.URBANIZATION' | translate }}</mat-label>
                  <input
                    matInput
                    formControlName="urbanization"
                    [ngModel]="urbanizationValue"
                    autocomplete="kt-doctor-urbanization"
                    (ngModelChange)="urbanizationValue = $event ? $event.toUpperCase() : ''"
                  />
                  <mat-error *ngIf="isControlHasError('urbanization', 'maxlength')">
                    Maximum length is 48 character
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.ADDRESS1">Address1</mat-label>
                  <input
                    matInput
                    formControlName="address_1"
                    [ngModel]="Address1Value"
                    autocomplete="kt-doctor-address-1"
                    (ngModelChange)="Address1Value = $event ? $event.toUpperCase() : ''"
                    required
                  />
                  <mat-error *ngIf="isControlHasError('address_1', 'maxlength')">
                    Maximum length is 48 character
                  </mat-error>
                  <mat-error *ngIf="isControlHasError('address_1', 'required')">
                    Address1 is required
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.ADDRESS2">Address2</mat-label>
                  <input
                    matInput
                    formControlName="address_2"
                    [ngModel]="Address2Value"
                    autocomplete="kt-doctor-address-2"
                    (ngModelChange)="Address2Value = $event ? $event.toUpperCase() : ''"
                  />
                  <mat-error *ngIf="isControlHasError('address_2', 'maxlength')">
                    Maximum length is 48 character
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.CITY">City</mat-label>
                  <input
                    matInput
                    formControlName="city"
                    [ngModel]="cityValue"
                    autocomplete="kt-doctor-city"
                    (ngModelChange)="cityValue = $event ? $event.toUpperCase() : ''"
                    required
                  />
                  <mat-error *ngIf="isControlHasError('city', 'maxlength')">
                    Maximum length is 30 character
                  </mat-error>
                  <mat-error *ngIf="isControlHasError('city', 'required')">
                    City is required
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.STATE">State</mat-label>
                  <mat-select formControlName="state" required>
                    <mat-option value="AL">AL</mat-option>
                    <mat-option value="AK">AK</mat-option>
                    <mat-option value="AR">AR</mat-option>
                    <mat-option value="AZ">AZ</mat-option>
                    <mat-option value="CA">CA</mat-option>
                    <mat-option value="CO">CO</mat-option>
                    <mat-option value="CT">CT</mat-option>
                    <mat-option value="DC">DC</mat-option>
                    <mat-option value="DE">DE</mat-option>
                    <mat-option value="FL">FL</mat-option>
                    <mat-option value="GA">GA</mat-option>
                    <mat-option value="HI">HI</mat-option>
                    <mat-option value="IA">IA</mat-option>
                    <mat-option value="ID">ID</mat-option>
                    <mat-option value="IL">IL</mat-option>
                    <mat-option value="IN">IN</mat-option>
                    <mat-option value="KS">KS</mat-option>
                    <mat-option value="KY">KY</mat-option>
                    <mat-option value="LA">LA</mat-option>
                    <mat-option value="MA">MA</mat-option>
                    <mat-option value="MD">MD</mat-option>
                    <mat-option value="ME">ME</mat-option>
                    <mat-option value="MI">MI</mat-option>
                    <mat-option value="MN">MN</mat-option>
                    <mat-option value="MO">MO</mat-option>
                    <mat-option value="MS">MS</mat-option>
                    <mat-option value="MT">MT</mat-option>
                    <mat-option value="NC">NC</mat-option>
                    <mat-option value="NE">NE</mat-option>
                    <mat-option value="NH">NH</mat-option>
                    <mat-option value="NJ">NJ</mat-option>
                    <mat-option value="NM">NM</mat-option>
                    <mat-option value="NV">NV</mat-option>
                    <mat-option value="NY">NY</mat-option>
                    <mat-option value="ND">ND</mat-option>
                    <mat-option value="OH">OH</mat-option>
                    <mat-option value="OK">OK</mat-option>
                    <mat-option value="OR">OR</mat-option>
                    <mat-option value="PA">PA</mat-option>
                    <mat-option value="PR">PR</mat-option>
                    <mat-option value="RI">RI</mat-option>
                    <mat-option value="SC">SC</mat-option>
                    <mat-option value="SD">SD</mat-option>
                    <mat-option value="TN">TN</mat-option>
                    <mat-option value="TX">TX</mat-option>
                    <mat-option value="UT">UT</mat-option>
                    <mat-option value="VT">VT</mat-option>
                    <mat-option value="VA">VA</mat-option>
                    <mat-option value="WA">WA</mat-option>
                    <mat-option value="WI">WI</mat-option>
                    <mat-option value="WV">WV</mat-option>
                    <mat-option value="WY">WY</mat-option>
                  </mat-select>
                  <mat-error *ngIf="isControlHasError('state', 'required')">
                    State is required
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.ZIP">Zip</mat-label>
                  <input
                    matInput
                    formControlName="zip"
                    maxlength="10"
                    [ngModel]="zipValue"
                    autocomplete="kt-doctor-zip-code"
                    (ngModelChange)="zipValue = $event ? putDash($event) : ''"
                    required
                  />
                  <mat-error *ngIf="isControlHasError('zip', 'required')">
                    Zip Code is required
                  </mat-error>
                  <mat-error *ngIf="isControlHasError('zip', 'pattern')">
                    Zip Code is invalid
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <h5 class="font-weight-bold mb-6">Extra details</h5>
            </div>
            <div class="form-group row">
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'DOCTOR.INPUT.DEA' | translate }}</mat-label>
                  <input matInput formControlName="dea" autocomplete="kt-doctor-dea" />
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'DOCTOR.INPUT.NPI' | translate }}</mat-label>
                  <input matInput formControlName="npi" autocomplete="kt-doctor-npi" />
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'DOCTOR.INPUT.SLN' | translate }}</mat-label>
                  <input matInput formControlName="sln" autocomplete="kt-doctor-sln" />
                </mat-form-field>
              </div>
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'DOCTOR.INPUT.NOTE' | translate }}</mat-label>
                  <textarea
                    matInput
                    formControlName="note"
                    rows="5"
                    maxlength="499"
                    [readonly]="readOnly"
                    autocomplete="kt-doctor-note"
                  ></textarea>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <h5 class="font-weight-bold mb-6">Tags</h5>
            </div>
            <div class="form-group row">
              <div class="col col-sm-12">
                <kt-tags
                  [autocompleteEntity]="'DOCTOR'"
                  [readOnlyValue]="tagsArr"
                  [readOnly]="isViewMode"
                  [controlObject]="tags"
                  [appearance]="'fill'"
                  [value]="tags$"
                  category="Entity"
                ></kt-tags>
              </div>
            </div>
            <div class="row">
              <h5 class="font-weight-bold mb-6">Last Modified</h5>
            </div>
            <div class="form-group row">
              <div class="ml-5">
                <mat-label>{{ doctor.last_modified_user }}</mat-label>
              </div>
            </div>
          </div>
          <!--end::Body-->
        </form>
        <!--end::Form-->
      </div>
      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[1].active">
        <div class="until-they">
          <kt-entity-relationships-list
            [entity_type]="'doctors'"
            [entity_id]="doctor?.id"
            (openList)="closeDialog($event)"
            (navigateToContact)="closeDialog($event)"
          ></kt-entity-relationships-list>
        </div>
      </div>
      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[2].active">
        <div class="until-they">
          <kt-note-list [entityId]="doctor?.id" [entityType]="NoteEntityType.DOCTOR"></kt-note-list>
        </div>
      </div>
      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[3].active">
        <div class="until-they">
          <kt-patients-list
            [fromDoctor]="true"
            [canvas]="!!entity_id"
            [entity_id_for_task_list]="doctor?.id"
            (navigateToPatient)="closeDialog($event)"
          ></kt-patients-list>
        </div>
      </div>
      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[4].active">
        <!--begin::Header-->
        <div class="card-header py-3">
          <div class="card-title align-items-start">
            <h3 class="card-label" style="align-self: center">Other Details</h3>
          </div>
          <div class="card-toolbar">
            <a
              href="javascript:"
              class="btn btn-primary mr-2"
              color="primary"
              (click)="onSubmit()"
              mat-raised-button
              matTooltip="Save & Continue"
            >
              <span class="hidden-mobile"> {{ 'AUTH.INPUT.SAVE' | translate }}</span>
            </a>
          </div>
        </div>
        <!--end::Header-->
        <div class="until-they">
          <div *ngIf="doctor">
            <form [formGroup]="doctorForm" class="form form-group-seperator-dashed">
              <div class="form-section form-section-first px-10">
                <div class="form-group row">
                  <div class="col-lg-12 card-header-doctor-form">
                    <h4>Specialties</h4>
                  </div>
                  <div class="col-lg-12 kt-margin-bottom-20-mobile">
                    <kt-general-autocomplete
                      [label]="'Doctor Specialties'"
                      [loadItemsFunction]="specialtiesAutocompleteCall"
                      [optionFormatter]="displaySpecialties"
                      [valueFormatter]="displaySpecialties"
                      [required]="false"
                      [readOnly]="false"
                      [control]="doctorForm.get('specialties')"
                      [objects]="doctorForm.get('specialties').value"
                      [change]="onSpecialtiesChange.bind(this)"
                      [chipList]="true"
                      [formatNewObjectFn]="formatNewSpecialtiesFn"
                      [dataPath]="'data'"
                      [placeholder]="'Select Specialty'"
                      #specialtiesAutocomplete
                    ></kt-general-autocomplete>
                    <kt-general-autocomplete
                      [label]="'Doctor Subspecialities'"
                      [loadItemsFunction]="subspecialitiesAutocompleteCall"
                      [optionFormatter]="displaySpecialties"
                      [valueFormatter]="displaySpecialties"
                      [required]="false"
                      [readOnly]="false"
                      [objects]="doctorForm.get('subspecialities').value"
                      [control]="doctorForm.get('subspecialities')"
                      [change]="onSubspecialitiesChange.bind(this)"
                      [chipList]="true"
                      [formatNewObjectFn]="formatNewSpecialtiesFn"
                      [dataPath]="'data'"
                      [placeholder]="'Select Subspecialities'"
                      #subspecialitiesAutocomplete
                    ></kt-general-autocomplete>
                  </div>
                </div>
              </div>
              <div class="form-section form-section-first px-10">
                <div class="form-group row">
                  <div class="col-lg-12 card-header-doctor-form">
                    <h4>Geolocation</h4>
                  </div>

                  <div class="col-lg-4 kt-margin-bottom-20-mobile">
                    <mat-form-field class="mat-form-field-fluid" appearance="fill">
                      <mat-label>Enter a plus code,address or (Longitude,Latitude)</mat-label>
                      <input
                        matInput
                        placeholder="Enter a plus code or an address"
                        formControlName="geolocation_address"
                      />
                    </mat-form-field>
                    <mat-form-field class="mat-form-field-fluid" appearance="fill">
                      <mat-label>Plus Code</mat-label>
                      <input matInput placeholder="Plus Code" formControlName="plus_code" />
                    </mat-form-field>
                    <mat-form-field class="mat-form-field-fluid" appearance="fill">
                      <mat-label>Latitude</mat-label>
                      <input matInput placeholder="Latitude" formControlName="latitude" />
                    </mat-form-field>
                    <mat-form-field class="mat-form-field-fluid" appearance="fill">
                      <mat-label>Longitude</mat-label>
                      <input matInput placeholder="Longitude" formControlName="longitude" />
                    </mat-form-field>
                    <a
                      (click)="searchForGeolocation()"
                      class="btn btn-primary"
                      color="primary"
                      mat-raised-button
                      matTooltip="Find GeoLocation"
                    >
                      <span>Find GeoLocation</span>
                    </a>
                    <a
                      (click)="resetGeolocation()"
                      class="ml-2 btn btn-secondary"
                      mat-raised-button
                      matTooltip="Reset"
                    >
                      <span class="hidden-mobile">Reset</span>
                    </a>
                  </div>
                  <div class="col-lg-8 kt-margin-bottom-20-mobile">
                    <agm-map
                      [zoom]="15"
                      [latitude]="doctorForm.get('latitude').value"
                      [longitude]="doctorForm.get('longitude').value"
                    >
                      <agm-marker
                        [latitude]="doctorForm.get('latitude').value"
                        (dragEnd)="markerDragEnd($event)"
                        [longitude]="doctorForm.get('longitude').value"
                        [markerDraggable]="true"
                      ></agm-marker>
                    </agm-map>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[5].active">
        <div class="until-they">
          <kt-sales-teams-list
            [fromDoctor]="true"
            [entity_id_for_task_list]="doctor?.id"
          ></kt-sales-teams-list>
        </div>
      </div>
      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[6].active">
        <div class="until-they">
          <kt-portlet>
            <kt-portlet-header title="Task list" [class]="'card-head-lg'"> </kt-portlet-header>
            <kt-portlet-body>
              <div class="mat-table-wrapper">
                <kt-task-list
                  [canvasShow]="true"
                  [fromDoctor]="true"
                  [doctor_id_for_task_list]="doctor?.id"
                ></kt-task-list>
              </div>
            </kt-portlet-body>
          </kt-portlet>
        </div>
      </div>
      <!--end::Card-->
      <div *ngIf="tabs[7].active" class="card card-custom card-stretch">
        <div class="until-they">
          <kt-document-list [entityId]="doctor?.id"></kt-document-list>
        </div>
      </div>
      <div *ngIf="tabs[8].active" class="card card-custom card-stretch">
        <div class="until-they">
          <kt-affiliations-list></kt-affiliations-list>
        </div>
      </div>
    </div>
    <!--end::Content-->
  </div>
  <!--end::Profile Personal Information-->
</div>
